import { createGlobalStyle } from "styled-components";
import { BREAKPOINTS } from "../../../app/appConstants";

export const GlobalNotificationsStyled = createGlobalStyle`
    :root {
      --toastify-color-dark: var(--color-background-secondary);
      --toastify-toast-width: 100%;
    }

    .Toastify__toast {
        padding: 8px;
        border-radius: 16px;
        background: var(--color-background-secondary);
        margin: 4px;
        
        .notification-close-button {
            position: absolute;
            right: 8px;
            top: 6px;
            font-size: 12px;
            color: var(--color-label-primary);
        }
        
        &.background-surface {
            background: var(--color-background-secondary);
            box-shadow: var(--shadow-primary);
        }
    }
    
    .Toastify__toast-body {
        padding: 0;
        &, & > div {
            overflow: hidden;
        }
    }

    .notification-margin-16 {
        margin: 16px;
    }

    .notification-position-closed {
        button {
            border-radius: 12px;
        }
    }

    .desktop-top-right-notifications {
        right: calc(224px + 24px);
        top: 76px;
        --toastify-toast-width: 360px;
    }

    @media (min-width: ${BREAKPOINTS.extraExtraLarge}px) {
        .desktop-top-right-notifications {
            right: calc(260px + 24px);
        }
    }
`;
